<div class="contentMain">
    <!-- breadcrumb -->
    <div class="row">
      <div class="col-md-12 card-header mainheader header-container-btn">
        <h5>Size Creation-EDIT Mode</h5>
      </div>
    </div>
    <!--/ breadcrumb-->
    <!-- main body -->
    <main class="row">
      <!-- card -->
      <div class="card">
        <!-- card body -->
        <div class="card-body">
          <form class="form">
            <div class="checkbox">
              <input id="active" type="checkbox" />
              <label for="active">Active </label>
            </div>
            <!-- row -->
            <div class="row">
              <!-- col -->
              <div class="col-lg-6 col-md-6 col-sm-6">
                <div class="form-group">
                  <label>Name</label>
                  <input type="text" class="form-control" placeholder="Name" />
                </div>
              </div>
              <!--/ col -->
              <!-- col -->
              <div class="col-lg-6 col-md-6 col-sm-6">
                <div class="form-group">
                  <label>Code</label>
                  <input type="text" class="form-control" placeholder="Code" />
                </div>
              </div>
              <!--/ col -->
              <!-- col -->
              <div class="col-lg-6 col-md-6 col-sm-6">
                <div class="form-group">
                  <label>Default Value</label>
                  <input
                    type="text"
                    class="form-control"
                    placeholder="Default Value"
                  />
                </div>
              </div>
              <!--/ col -->
            </div>
            <!--/ row -->
          </form>
         
        </div>
        <div class="card-footer text-left w-100">
            <button class="btn redbtn" type="button">New</button>
            <button class="btn redbtn" type="button">F3-Save</button>
            <button class="btn redbtn" type="button">Edit</button>
            <button class="btn redbtn" type="button">Delete</button>
            <button class="btn redbtn" type="button">Clear</button>
            <button class="btn redbtn" type="button">Cancel</button>
          </div>
        <!--/ card body -->
      </div>
      <!--/ card -->
    </main>
    <!-- main body -->
  </div>
  <div class="modal fade" id="newsizecreation" tabindex="-1" role="dialog">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="title" id="defaultModalLabel">Create New Size</h4>
        </div>
        <div class="modal-body">
          <form class="form">
            <div class="checkbox">
              <input id="active" type="checkbox" />
              <label for="active">Active </label>
            </div>
            <!-- row -->
            <div class="row">
              <!-- col -->
              <div class="col-lg-12 col-md-12">
                <div class="form-group">
                  <label>Name</label>
                  <input type="text" class="form-control" placeholder="Name" />
                </div>
              </div>
              <!--/ col -->
              <!-- col -->
              <div class="col-lg-12 col-md-12">
                <div class="form-group">
                  <label>Code</label>
                  <input type="text" class="form-control" placeholder="Code" />
                </div>
              </div>
              <!--/ col -->
              <!-- col -->
              <div class="col-lg-12 col-md-12">
                <div class="form-group">
                  <label>Default Value</label>
                  <input
                    type="text"
                    class="form-control"
                    placeholder="Default Value"
                  />
                </div>
              </div>
              <!--/ col -->
            </div>
            <!--/ row -->
          </form>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn redbtn waves-effect">
            SAVE CHANGES
          </button>
          <button
            type="button"
            class="btn redbtn waves-effect"
            data-dismiss="modal"
          >
            CLOSE
          </button>
        </div>
      </div>
    </div>
  </div>
  